import { createFileRoute, Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { ContactForm } from "@/components/contact/ContactForm";
import { EmphasizedTitle } from "@/components/site/EmphasizedTitle";
import {
  SITE_ADDRESS,
  SITE_EMAIL,
  SITE_MAPS_URL,
  SITE_PHONE,
  SITE_PHONE_TEL,
} from "@/lib/site-info";
import { pageHead } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/contact")({
  head: () =>
    pageHead({
      title: m.contact_meta_title(),
      description: m.contact_meta_description({ email: SITE_EMAIL }),
      path: "/contact",
    }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <>
      <section className="bg-ink">
        <div className="container-page page-hero-pad">
          <span className="eyebrow">{m.contact_eyebrow()}</span>
          <h1 className="mt-3 max-w-3xl font-display text-hero leading-[0.95] md:text-8xl">
            <EmphasizedTitle lead={m.contact_title_lead()} accent={m.contact_title_accent()} />
          </h1>
          <p className="mt-5 max-w-xl text-foreground/80">{m.contact_intro()}</p>
        </div>
      </section>

      <section className="container-page page-follow-pad">
        <div className="grid gap-px bg-white/10 md:grid-cols-2">
          <div className="bg-ink p-9">
            <Phone className="h-6 w-6 text-ember" />
            <h2 className="mt-4 font-display text-2xl">{m.contact_phone()}</h2>
            <p className="mt-2 text-sm text-foreground/70">{m.contact_phone_hint()}</p>
            <a
              href={SITE_PHONE_TEL}
              className="mt-4 inline-block font-display text-xl tracking-[0.1em] hover:text-ember"
            >
              {SITE_PHONE}
            </a>
          </div>
          <div className="bg-ink p-9">
            <Mail className="h-6 w-6 text-ember" />
            <h2 className="mt-4 font-display text-2xl">{m.contact_email()}</h2>
            <p className="mt-2 text-sm text-foreground/70">{m.contact_email_hint()}</p>
            <a
              href={`mailto:${SITE_EMAIL}`}
              className="mt-4 inline-block text-foreground/80 hover:text-ember"
            >
              {SITE_EMAIL}
            </a>
          </div>
          <div className="bg-ink p-9">
            <MapPin className="h-6 w-6 text-ember" />
            <h2 className="mt-4 font-display text-2xl">{m.contact_location()}</h2>
            <p className="mt-2 text-sm text-foreground/70">{m.contact_location_hint()}</p>
            <a
              href={SITE_MAPS_URL}
              className="mt-4 inline-block text-foreground/80 hover:text-ember"
            >
              <bdi dir="ltr">{SITE_ADDRESS.full}</bdi>
            </a>
          </div>
          <div className="bg-ink p-9">
            <Clock className="h-6 w-6 text-ember" />
            <h2 className="mt-4 font-display text-2xl">{m.contact_hours()}</h2>
            <p className="mt-2 text-sm text-foreground/70">{m.contact_hours_hint()}</p>
            <p className="mt-4 text-foreground/80">{m.site_hours()}</p>
          </div>
        </div>

        <ContactForm />

        <Link to="/schedule" className="btn-ember btn-ember-hover mt-12">
          {m.contact_cta_book()} <ArrowRight className="h-5 w-5 rtl:rotate-180" />
        </Link>
      </section>
    </>
  );
}
